import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { ApiClient } from '../common/api-client.service';

export interface SessionData {
  token: string;
  user: SessionUserData;
}

export interface SessionUserData {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  admin: boolean;
}

const SmartCheckTTL: number = 1000 * 60;

@Injectable()
export class SessionService {
  subject: Subject<SessionData> = new Subject();
  private cachedSession: SessionData;
  private lastSmartCheck = 0;

  constructor(
    private apiClient: ApiClient,
  ) {}

  user(): SessionUserData {
    if ( this.cachedSession ) {
      return this.cachedSession.user;
    }
  }

  smartCheck(): Promise<SessionData> {
    const now = (new Date()).getTime();
    if ( !this.hasToken() ) {
      return Promise.reject('No session token');
    } else if ( this.cachedSession && (now - this.lastSmartCheck) < SmartCheckTTL ) {
      return Promise.resolve(this.cachedSession);
    } else {
      return this.check().then(sess => {
        this.cachedSession ? this.set(sess) : this.start(sess);
        return sess;
      }, msg => {
        this.clear();
        return Promise.reject(msg);
      })
    }
  }

  start(sess: SessionData): void {
    this.set(sess);
    this.subject.next(sess);
  }

  setUser(user: SessionUserData): void {
    this.cachedSession.user = user;
  }

  destroy(): Promise<void> {
    // TODO log out on server
    this.clear();
    return Promise.resolve();
  }

  observable(): Observable<SessionData> {
    return this.subject.asObservable();
  }

  private set(sess: SessionData): void {
    this.setToken(sess.token);
    this.cachedSession = sess;
    this.lastSmartCheck = (new Date()).getTime();
  }

  private clear() {
    localStorage.removeItem('auth_token');
    this.cachedSession = null;
    this.lastSmartCheck = 0;
    this.subject.next(null);
  }

  private check(): Promise<SessionData> {
    return this.apiClient.get<SessionData>('/api/v1/login').toPromise().
      catch(() => Promise.reject('Invalid or expired session'));
  }

  private hasToken(): boolean {
    return !!this.getToken();
  }

  private getToken(): string {
    return localStorage.getItem('auth_token');
  }

  private setToken(token: string): void {
    localStorage.setItem('auth_token', token);
  }
}



// WEBPACK FOOTER //
// /srv/src/app/common/session.service.ts